import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    dateRangePickerWrapper: {
        '& *': {
            fontFamily: 'Now, Arial !important',
        },
    },
}));